import { graphql } from 'gatsby';
import React from 'react';
import { Box } from 'lucid-components-react';

import { LucidTheme } from 'types/types';
import {
  Drupal_ParagraphImageSection,
  Drupal_ParagraphSeoImage
} from 'generated/graphql';
import { mqMin } from 'theme/base';

const FlexiImageSection = ({
  entity: { fieldImageSectionImage, fieldMaxDesktopWidth }
}: {
  entity: {
    fieldImageSectionImage: { entity: Drupal_ParagraphSeoImage };
    fieldMaxDesktopWidth: Drupal_ParagraphImageSection['fieldMaxDesktopWidth'];
  };
}) => {
  return (
    <Box
      css={(theme: LucidTheme) => ({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        marginTop: theme.space[6],
        marginBottom: theme.space[6]
      })}
      gridColumn={'1 / -1'}
    >
      <Box css={{ textAlign: 'center' }}>
        {/*eslint-disable-next-line jsx-a11y/alt-text*/}
        <img
          alt={fieldImageSectionImage?.entity?.fieldAltText || ''}
          css={{
            maxWidth: '100%',
            [mqMin.tabletLandscape]: {
              maxWidth: `${fieldMaxDesktopWidth}%`
            }
          }}
          src={fieldImageSectionImage?.entity?.fieldImageLink || ''}
        />
      </Box>
    </Box>
  );
};

export default FlexiImageSection;

export const query = graphql`
  fragment flexiImageSection on Drupal_ParagraphImageSection {
    fieldMaxDesktopWidth
    fieldImageSectionImage {
      entity {
        ... on Drupal_ParagraphSeoImage {
          fieldImageLink
          fieldAltText
        }
      }
    }
  }
`;
